import { PostProperties } from "../types";
import image from "../img/lostGemJeffMills.jpg";

const post: PostProperties = {
  id: 32,
  title: "Jeff Mills - Blue Potential Promo, Skyrave (28.05.2006)",
  content: `This special mix comes straight from the source of techno music - Jeff Mills. Originally, this mix was created for the Skyrave radio show and broadcast on Skyrock radio. The first 34 minutes of the mix are a promo for the then-upcoming DVD "Blue Potential" by Jeff Mills. Blue Potential presents techno music by Mills accompanied by the Philharmonic Orchestra of Montpellier. The remaining hour and a half of the recording is an old-school house mix by the master himself.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/jeff-mills-blue-potential-promo-skyrave-28052006",
  category: "Lost Gem",
  translationsBg: {
    content: `Този специален микс идва директно от източника на техно музиката - Джеф Милс. Първоначално миксът е създаден за радиопредаването Skyrave и е излъчен по радио Skyrock. Първите 34 минути от микса са промо за предстоящото тогава DVD "Blue Potential" на Джеф Милс. Blue Potential представя техно музика от Милс, акомпанирана от Филхармоничния оркестър на Монпелие. Останалият час и половина от записа е олдскуул хаус микс от самия майстор.`,
  },
};

export default post;
